const tipTapToolbarStyles = {
  container: (stickyTop: `${number}rem`) => ({
    position: "sticky",
    top: stickyTop,
    backgroundColor: "background.paper",
    zIndex: 1,
  }),
};

export default tipTapToolbarStyles;
